// extracted by mini-css-extract-plugin
module.exports = {"floatingburger":"search_floatingburger__1D56i","relativepos":"search_relativepos__1HjVT","criteria_summary":"search_criteria_summary__2yQaO"};